(function (scope) {
  'use strict';
  const LINK = '[data-dt-cookie-preferences]';
  const HASH = '#shopifyReshowConsentBanner';
  function install(env) {
    if (env.__dotsonCookiePreferences) return env.__dotsonCookiePreferences;
    let pending = null;
    function message(text) {
      for (const node of env.document.querySelectorAll('[data-dt-cookie-preferences-status]')) {
        node.textContent = text;
        node.hidden = !text;
      }
    }
    function ready() {
      return new Promise((resolve, reject) => {
        let tries = 0;
        function inspect() {
          if (typeof env.privacyBanner?.showPreferences === 'function') { resolve(env.privacyBanner); return; }
          if (++tries >= 80) { reject(new Error('Native preferences unavailable')); return; }
          env.setTimeout(inspect, 100);
        }
        inspect();
      });
    }
    async function open() {
      if (pending) return pending;
      message('Opening cookie preferences…');
      for (const link of env.document.querySelectorAll(LINK)) link.setAttribute('aria-busy', 'true');
      pending = (async () => {
        try {
          // Official Cookie Banner API, verified in this store's native bundle.
          // This opens Shopify's dialog; only its Save/Accept/Decline controls
          // can change a visitor's consent. Never write Shopify cookies here.
          const banner = await ready();
          await banner.showPreferences();
          message('');
          return true;
        } catch (_) {
          message('Cookie preferences could not open. Please try again or reload this page.');
          return false;
        } finally {
          for (const link of env.document.querySelectorAll(LINK)) link.removeAttribute('aria-busy');
          pending = null;
        }
      })();
      return pending;
    }
    function click(event) {
      if (!event.target?.closest?.(LINK)) return;
      // Prevent Shopify's matching delegated anchor handler from opening twice.
      // Modified clicks can still follow the real policy URL in another tab.
      event.stopImmediatePropagation();
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      void open();
    }
    env.document.addEventListener('click', click, true);
    env.__dotsonCookiePreferences = {open};
    // The native bundle matches clicks, not initial URL hashes. This preserves
    // the fallback when an early click or a direct link navigated to the policy.
    if (env.location.hash === HASH) void open();
    return env.__dotsonCookiePreferences;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {install};
  else install(scope);
})(typeof window !== 'undefined' ? window : globalThis);
